module.exports = __webpack_public_path__ + "static/media/main idea.3f002a13.mp3";